<template>
  <v-app>
    <Loading v-if="loading" />

    <template v-else>
      <Header />
      <router-view />
      <Footer />

      <FixedApps />
      <CookieBanner />
    </template>
  </v-app>
</template>

<script>
import Loading from "./components/widgets/Loading.vue";
import Header from "./components/shell/header/Index.vue";
import Footer from "./components/shell/Footer.vue";
import FixedApps from "./components/widgets/FixedApps.vue";
import CookieBanner from "./components/widgets/CookieBanner.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      if (!this.$rest("informations").item) return "";
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = !this.name
        ? this.$route.name
        : `${this.$route.name} - ${this.name}`;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  mounted() {
    this.$rest("informations").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("products-categories")
      .get()
      .then(() => (this.loading = false));
  },
  created() {
    this.updateDocumentTitle();
  },
  components: {
    Loading,
    Header,
    Footer,
    FixedApps,
    CookieBanner,
  },
};
</script>

<style>
.component-title {
  /* background-image: url(/img/bg/footer.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover; */
}

@media screen and (min-width: 1200px) {
  .container {
    max-width: 1194px !important;
  }
}

.filter-white {
  filter: brightness(0) invert(1);
}

.theme--light.v-pagination .v-pagination__item,
.theme--light.v-pagination .v-pagination__navigation {
  height: 50px;
  font-size: 18px;
  width: 50px;
}

.theme--light.v-pagination .v-pagination__navigation .v-icon {
  font-size: 18px;
}

.light-gallery__modal {
  z-index: 99999999 !important;
}
</style>
